import { HttpClient } from "./types";

export interface SiteSubscriptionStatusDTO {
    bloqueada: boolean;
}

export const createSiteSubscriptionStatusService = (httpClient: HttpClient) => {
    return {
        get: (): Promise<SiteSubscriptionStatusDTO> => {
            return httpClient.get<SiteSubscriptionStatusDTO>(
                "/tienda/suscripcion/estado-sitio-web",
            );
        },
    };
};
